/**
 * @generated SignedSource<<8cafe63543cb58a89a620ccf855ab670>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeatureId = "getAnswers" | "potentialAnalysisV2" | "test";
export type Permission = "AccountPermission_AVGS_IsAVGSAccount" | "AccountPermission_AZAVAdmin_IsAZAVAccount" | "AccountPermission_AccountMemberManagement_CanInviteOrAddUsersToUserInAccountGroups" | "AccountPermission_Auth_IsBusinessAccount" | "AccountPermission_Auth_usePlacement" | "AccountPermission_CoachingCoachProfileAdmin_IsCoachAccount" | "AccountPermission_PotentialAnalysis_IsPotentialAnalysisAccount" | "AccountPermission_System_Root" | "UserInAccountPermission_AVGS_IsAVGSAdmin" | "UserInAccountPermission_AVGS_IsAVGSCoach" | "UserInAccountPermission_AVGS_ModifyAdmin" | "UserInAccountPermission_AVGS_ReadAdmin" | "UserInAccountPermission_AZAVAdmin_Modify" | "UserInAccountPermission_AZAVAdmin_Read" | "UserInAccountPermission_AsyncElementTaskAdmin_Modify" | "UserInAccountPermission_AsyncElementTaskAdmin_Read" | "UserInAccountPermission_AuthAdmin_MinimalRead" | "UserInAccountPermission_AuthAdmin_Modify" | "UserInAccountPermission_AuthAdmin_Read" | "UserInAccountPermission_Auth_Modify" | "UserInAccountPermission_Auth_Read" | "UserInAccountPermission_CachingAdmin_Modify" | "UserInAccountPermission_CoachBillingAdmin_Read" | "UserInAccountPermission_CoachFeedback_Read" | "UserInAccountPermission_CoachingAvailabilityAdmin_ModifyAvailability" | "UserInAccountPermission_CoachingAvailabilityAdmin_ReadAvailability" | "UserInAccountPermission_CoachingCoachProfileAdmin_ModifyCoachProfiles" | "UserInAccountPermission_CoachingCoachProfileAdmin_ReadCoachProfiles" | "UserInAccountPermission_CoachingOfferAdmin_Modify" | "UserInAccountPermission_CoachingOfferAdmin_Read" | "UserInAccountPermission_ContractPartnerAdmin_Modify" | "UserInAccountPermission_ContractPartnerAdmin_Read" | "UserInAccountPermission_CustomerFeedback_Modify" | "UserInAccountPermission_CustomerFeedback_Read" | "UserInAccountPermission_DiscountAdmin_Modify" | "UserInAccountPermission_DiscountAdmin_Read" | "UserInAccountPermission_Email_Templates" | "UserInAccountPermission_ExternalLicenseAdmin_Modify" | "UserInAccountPermission_ExternalLicenseAdmin_Read" | "UserInAccountPermission_FeatureToggleAdmin_Modify" | "UserInAccountPermission_FeatureToggleAdmin_Read" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_GenerateCartLinkAdmin_Modify" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnableAdmin_Modify" | "UserInAccountPermission_LearnableAdmin_Read" | "UserInAccountPermission_LicenseAdmin_Modify" | "UserInAccountPermission_LicenseAdmin_Read" | "UserInAccountPermission_LicenseDefinitionAdmin_Modify" | "UserInAccountPermission_LicenseDefinitionAdmin_Read" | "UserInAccountPermission_LimitedCartDiscountAdmin_Modify" | "UserInAccountPermission_LimitedCartDiscountAdmin_Read" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_OrderAdmin_Modify" | "UserInAccountPermission_OrderAdmin_Read" | "UserInAccountPermission_PlacementContactPerson_Access" | "UserInAccountPermission_PotentialAnalysis_IsPotentialAnalysisAdmin" | "UserInAccountPermission_PotentialAnalysis_IsPotentialAnalysisCoach" | "UserInAccountPermission_PotentialAnalysis_ModifyAdmin" | "UserInAccountPermission_PotentialAnalysis_ReadAdmin" | "UserInAccountPermission_ProductAdmin_Modify" | "UserInAccountPermission_ProductAdmin_Read" | "UserInAccountPermission_ReportAdmin_Modify" | "UserInAccountPermission_ReportAdmin_Read" | "UserInAccountPermission_SettingsAdmin_Modify" | "UserInAccountPermission_SettingsAdmin_Read" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_TagAdmin_Modify" | "UserInAccountPermission_TagAdmin_Read" | "UserInAccountPermission_TagAdmin_Select" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TreeUnlockedStateAdmin_Modify" | "UserInAccountPermission_TreeUnlockedStateAdmin_Read" | "UserInAccountPermission_Trend_Modify" | "UserInAccountPermission_Trend_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_V2MigrationAdmin_Convert" | "UserInAccountPermission_VimeoVideoSourceAdmin_Modify" | "UserInAccountPermission_VimeoVideoSourceAdmin_Read" | "UserInAccountPermission_VocabAdmin_ModifyWordPackages" | "UserInAccountPermission_VocabAdmin_ReadWordPackages";
export type permissionBasedNavigation_Query$variables = {};
export type permissionBasedNavigation_Query$data = {
  readonly FeatureToggle: {
    readonly ActiveFeatureToggleIds: ReadonlyArray<FeatureId>;
  };
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly permissionsInAccount: ReadonlyArray<Permission>;
        readonly user: {
          readonly id: string;
        };
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"accountSwitchMenu_AuthViewerSchemaFragment" | "navbar_AuthViewerSchemaFragment" | "profileMenu_AuthViewerSchemaFragment">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"userNotifications_ViewerQueryTypeFragment">;
  };
};
export type permissionBasedNavigation_Query = {
  response: permissionBasedNavigation_Query$data;
  variables: permissionBasedNavigation_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissionsInAccount",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "FeatureToggleQueries",
  "kind": "LinkedField",
  "name": "FeatureToggle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ActiveFeatureToggleIds",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "permissionBasedNavigation_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountSwitchMenu_AuthViewerSchemaFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "navbar_AuthViewerSchemaFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "profileMenu_AuthViewerSchemaFragment"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "userNotifications_ViewerQueryTypeFragment"
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "permissionBasedNavigation_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "userExtensionKind",
                            "value": "Academies"
                          }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "thumbnail",
                                    "storageKey": null
                                  },
                                  (v0/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "url",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sumGamificationPoints",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "potentialAnalysisMaxRewardAcknowledged",
                                "storageKey": null
                              }
                            ],
                            "type": "AcademiesUserExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": "extension(userExtensionKind:\"Academies\")"
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PotentialAnalysisViewerSchema",
            "kind": "LinkedField",
            "name": "PotentialAnalysis",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PotentialAnalysisResult",
                "kind": "LinkedField",
                "name": "MyPotentialAnalysisResult",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLongAnalysis",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e24c43c8765423819943296b6de1e748",
    "id": null,
    "metadata": {},
    "name": "permissionBasedNavigation_Query",
    "operationKind": "query",
    "text": "query permissionBasedNavigation_Query {\n  Viewer {\n    Auth {\n      currentUser {\n        user {\n          id\n        }\n        permissionsInAccount\n      }\n      ...accountSwitchMenu_AuthViewerSchemaFragment\n      ...navbar_AuthViewerSchemaFragment\n      ...profileMenu_AuthViewerSchemaFragment\n    }\n    ...userNotifications_ViewerQueryTypeFragment\n  }\n  FeatureToggle {\n    ActiveFeatureToggleIds\n  }\n}\n\nfragment accountSwitchMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      ...userAvatar_UserFragment\n      name\n      id\n    }\n    accounts {\n      id\n      name\n    }\n  }\n}\n\nfragment accountsDropdown_CurrentUserFragment on CurrentUser {\n  accounts {\n    id\n    name\n  }\n}\n\nfragment avatarWithProfileMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      ...userAvatar_UserFragment\n      id\n    }\n  }\n  ...accountSwitchMenu_AuthViewerSchemaFragment\n}\n\nfragment microLearningReward_ViewerQueryTypeFragment on ViewerQueryType {\n  Auth {\n    currentUser {\n      user {\n        extension(userExtensionKind: Academies) {\n          __typename\n          ... on AcademiesUserExtension {\n            potentialAnalysisMaxRewardAcknowledged\n          }\n        }\n        id\n      }\n    }\n  }\n  PotentialAnalysis {\n    MyPotentialAnalysisResult {\n      isLongAnalysis\n    }\n  }\n}\n\nfragment navbar_AuthViewerSchemaFragment on AuthViewerSchema {\n  ...avatarWithProfileMenu_AuthViewerSchemaFragment\n}\n\nfragment profileMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      name\n      extension(userExtensionKind: Academies) {\n        __typename\n        ... on AcademiesUserExtension {\n          avatar {\n            url\n            id\n          }\n          sumGamificationPoints\n        }\n      }\n      ...userAvatar_UserFragment\n      id\n    }\n    accounts {\n      id\n    }\n    ...accountsDropdown_CurrentUserFragment\n  }\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n\nfragment userNotifications_ViewerQueryTypeFragment on ViewerQueryType {\n  ...microLearningReward_ViewerQueryTypeFragment\n}\n"
  }
};
})();

(node as any).hash = "b0c95a07bb817601cc582fb384aa9f57";

export default node;
